import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { FieldBase, IFieldBaseProps } from '../Base';
import { colorFieldStyles } from './styles';

export interface IColorFieldProps
  extends Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'type'
  > {
  containerProps?: IFieldBaseProps;
  orientation?: 'vertical' | 'horizontal';
}

export function ColorField({
  className = '',
  containerProps,
  disabled = false,
  name,
  orientation = 'horizontal',
  readOnly = false,
  value,
  ...rest
}: IColorFieldProps): JSX.Element {
  return (
    <FieldBase
      disabled={disabled || readOnly || containerProps?.disabled}
      {...containerProps}
    >
      <div className={colorFieldStyles.container({ orientation })}>
        <input
          className={colorFieldStyles.input({
            disabled: disabled || readOnly,
            className,
          })}
          disabled={disabled}
          id={name}
          name={name}
          readOnly={readOnly}
          type="color"
          value={value}
          {...rest}
        />
        <span className={colorFieldStyles.color()}>{value}</span>
      </div>
    </FieldBase>
  );
}
